<template>
    <div>
        <b-modal id="m-upload-excel" title="Upload Excel Item" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group>
                <b-form-file
                    v-model="fileUpload"
                    :state="Boolean(fileUpload)"
                    placeholder="Pilih file excel"
                    drop-placeholder="Tarik dan lepas file disini"
                    accept=".xlsx, .xls"
                />
                <small class="text-muted">* File harus berformat .xlsx atau .xls</small> <br />
                <small class="text-muted">* Kolom A: Nomor Faktur</small> <br />
                <small class="text-muted">* Baris pertama akan diabaikan (header)</small>
            </b-form-group>
            <b-button
                variant="primary"
                class="mt-2"
                @click="importExcel"
                :disabled="!fileUpload || isSubmitting"
            >
                <i class="fa fa-upload mr-2" v-if="!isSubmitting" />
                {{ isSubmitting ? 'Mengupload...' : 'Unggah' }}
            </b-button>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        batchId: { type: Number, required: true }
    },
    data() {
        return {
            fileUpload: null,
            isSubmitting: false
        };
    },
    methods: {
        open() {
            this.fileUpload = null;
            this.$bvModal.show("m-upload-excel");
        },

        importExcel() {
            if (!this.fileUpload) {
                return this.$helper.toastError(this, "File tidak ditemukan!");
            }

            this.isSubmitting = true;
            const formData = new FormData();
            formData.append("file", this.fileUpload);

            this.$axios
                .post(`gold-batches/${this.batchId}/upload-excel`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                .then(() => {
                    this.$helper.toastSuccess(this, "Berhasil mengupload file!");
                    this.fileUpload = null;
                    this.$bvModal.hide("m-upload-excel");
                    this.$emit("uploaded");
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isSubmitting = false;
                });
        }
    }
};
</script>
